// import { useState } from 'react'
// import { Container, Row, Col, Button } from 'react-bootstrap'
// import {
//   Settings,
//   Bell,
//   Lock,
//   Users,
//   Download,
//   Trash2,
//   Eye,
//   ArrowLeft,
// } from 'lucide-react'
// import { useNavigate } from 'react-router-dom'
// import { LoginInformation } from '../Pages/LoginInformation'
// import { NotificationSettings } from '../Pages/NotificatonSettings'
// import { Privacy } from '../Pages/Privacy'
// import { GroupInvites } from '../Pages/GroupInvites'
// import { ExportData } from '../Pages/ExportData'
// import { DeleteAccount } from '../Pages/DeleteAcc'
// import Header from './Header'

// export default function SettingsLayout() {
//   const [activePage, setActivePage] = useState('login')
//   const navigate = useNavigate()

//   return (
//     <>
//       <Header />
//       <Container className='py-4 mt-6'>
//         <div className='d-flex justify-content-between align-items-center mb-4'>
//           <div className='d-flex align-items-center gap-3'>
//             <Button
//               variant='link'
//               className='text-decoration-none'
//               onClick={() => navigate(-1)} // Navigate to the previous page
//             >
//               <ArrowLeft size={16} className='me-2' />
//               Go Back
//             </Button>
//             <h1 className='h2 mb-0'>Account Settings</h1>
//           </div>
//           <Button
//             variant='link'
//             className='text-muted text-decoration-none'
//             onClick={() => {
//               /* Handle profile view */
//             }}
//           >
//             <Eye size={16} className='me-2' />
//             View Profile
//           </Button>
//         </div>

//         <Row>
//           <Col md={3}>
//             <div className='d-flex flex-column gap-2'>
//               <Button
//                 variant={activePage === 'login' ? 'light' : 'link'}
//                 className='text-start px-3 py-2'
//                 onClick={() => setActivePage('login')}
//               >
//                 <Settings size={16} className='me-2' />
//                 Login Information
//               </Button>
//               <Button
//                 variant={activePage === 'notifications' ? 'light' : 'link'}
//                 className='text-start px-3 py-2'
//                 onClick={() => setActivePage('notifications')}
//               >
//                 <Bell size={16} className='me-2' />
//                 Notification Settings
//               </Button>
//               <Button
//                 variant={activePage === 'privacy' ? 'light' : 'link'}
//                 className='text-start px-3 py-2'
//                 onClick={() => setActivePage('privacy')}
//               >
//                 <Lock size={16} className='me-2' />
//                 Privacy
//               </Button>
//               <Button
//                 variant={activePage === 'groupinvites' ? 'light' : 'link'}
//                 className='text-start px-3 py-2'
//                 onClick={() => setActivePage('groupinvites')}
//               >
//                 <Users size={16} className='me-2' />
//                 Group Invites
//               </Button>
//               <Button
//                 variant={activePage === 'exportdata' ? 'light' : 'link'}
//                 className='text-start px-3 py-2'
//                 onClick={() => setActivePage('exportdata')}
//               >
//                 <Download size={16} className='me-2' />
//                 Export Data
//               </Button>
//               {/* <Button
//                 variant={activePage === 'deleteaccount' ? 'light' : 'link'}
//                 className="text-start px-3 py-2 text-danger"
//                 onClick={() => setActivePage('deleteaccount')}
//               >
//                 <Trash2 size={16} className="me-2" />
//                 Delete Account
//               </Button> */}
//             </div>
//           </Col>
//           <Col md={9}>
//             {activePage === 'login' && <LoginInformation />}
//             {activePage === 'notifications' && <NotificationSettings />}
//             {activePage === 'privacy' && <Privacy />}
//             {activePage === 'groupinvites' && <GroupInvites />}
//             {activePage === 'exportdata' && <ExportData />}
//             {activePage === 'deleteaccount' && <DeleteAccount />}
//           </Col>
//         </Row>
//       </Container>
//     </>
//   )
// }
import { useState } from "react";
import { Container, Row, Col, useAccordionButton } from "react-bootstrap";
import {
  Settings,
  Bell,
  Lock,
  Users,
  Download,
  Trash2,
  Eye,
  ArrowLeft,
  Menu,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { LoginInformation } from "../Pages/LoginInformation";
import { NotificationSettings } from "../Pages/NotificatonSettings";
import { Privacy } from "../Pages/Privacy";
import { GroupInvites } from "../Pages/GroupInvites";
import { ExportData } from "../Pages/ExportData";
import { DeleteAccount } from "../Pages/DeleteAcc";
import Header from "./Header";

export default function SettingsLayout() {
  const [activePage, setActivePage] = useState("login");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const sidebarStyle = {
    background: "#f4811ee5",
    padding: "20px",
    borderRadius: "12px",
    color: "white",
    height: "100%",
    position: "fixed",
    overflowY: "auto",
    width: "280px",
    // Mobile styles
    "@media (max-width: 767px)": {
      position: "fixed",
      top: 0,
      left: mobileMenuOpen ? 0 : "-100%",
      zIndex: 1000,
      width: "280px",
      transition: "all 0.3s ease",
      maxHeight: "100vh",
    },
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 999,
    display: mobileMenuOpen ? "block" : "none",
  };

  const buttonStyle = (isActive) => ({
    backgroundColor: isActive ? "white" : "transparent",
    border: "none",
    textAlign: "left",
    padding: "12px 16px",
    color: isActive ? "#f4811ee5" : "white",
    borderRadius: "8px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease",
    width: "100%",
    marginBottom: "8px",
  });

  const contentStyle = {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    minHeight: "500px",
    // Mobile styles
    "@media (max-width: 767px)": {
      marginLeft: 0,
      width: "100%",
    },
  };

  const goBackStyle = {
    background: "none",
    border: "none",
    color: "white",
    fontWeight: "500",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    padding: 0,
    marginBottom: "20px",
  };

  const mobileMenuButtonStyle = {
    background: "#f4811ee5",
    border: "none",
    color: "white",
    padding: "10px",
    borderRadius: "5px",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // Hide on desktop
    "@media (min-width: 768px)": {
      display: "none",
    },
  };

  const handleMenuItemClick = (page) => {
    setActivePage(page);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <Header />
      <Container
        fluid
        style={{
          padding: "20px",
          background: "#f0f2f5",
          minHeight: "100vh",
          marginTop: "50px",
        }}
      >
        {/* Mobile menu button */}
        {/* <button 
          style={mobileMenuButtonStyle}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          <span style={{ marginLeft: '8px' }}>
            {mobileMenuOpen ? 'Close' : 'Menu'}
          </span>
        </button> */}

        {/* Mobile overlay */}
        <div style={overlayStyle} onClick={() => setMobileMenuOpen(false)} />

        <Row>
          <Col md={3} style={{ paddingLeft: 0 }}>
            <div style={sidebarStyle}>
              <button style={goBackStyle} onClick={() => navigate(-1)}>
                <ArrowLeft size={16} style={{ marginRight: "6px" }} />
                Go Back
              </button>
              <div className="d-flex flex-column gap-2">
                <button
                  style={buttonStyle(activePage === "login")}
                  onClick={() => handleMenuItemClick("login")}
                >
                  <Settings size={16} style={{ marginRight: "10px" }} />
                  Login Information
                </button>
                {/* <button
                  style={buttonStyle(activePage === 'notifications')}
                  onClick={() => handleMenuItemClick('notifications')}
                >
                  <Bell size={16} style={{ marginRight: '10px' }} />
                  Notification Settings
                </button>
                <button
                  style={buttonStyle(activePage === 'privacy')}
                  onClick={() => handleMenuItemClick('privacy')}
                >
                  <Lock size={16} style={{ marginRight: '10px' }} />
                  Privacy
                </button>
                <button
                  style={buttonStyle(activePage === 'groupinvites')}
                  onClick={() => handleMenuItemClick('groupinvites')}
                >
                  <Users size={16} style={{ marginRight: '10px' }} />
                  Group Invites
                </button>
                <button
                  style={buttonStyle(activePage === 'exportdata')}
                  onClick={() => handleMenuItemClick('exportdata')}
                >
                  <Download size={16} style={{ marginRight: '10px' }} />
                  Export Data
                </button>
                <button
                  style={{
                    ...buttonStyle(activePage === 'deleteaccount'),
                    color: '#ff4d4f',
                  }}
                  onClick={() => handleMenuItemClick('deleteaccount')}
                >
                  <Trash2 size={16} style={{ marginRight: '10px' }} />
                  Delete Account
                </button> */}
              </div>
            </div>
          </Col>
          <Col md={9} style={{ paddingLeft: 0 }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2
                className="text-center w-100 mb-0"
                style={{
                  backgroundColor: "#B8529E",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  display: "inline-block",
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  width: "100%",
                  margin: "0 auto",
                }}
              >
                Account Settings
              </h2>
              {/* Hide on mobile */}
              {/* <button
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#6c757d',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  '@media (max-width: 767px)': {
                    display: 'none'
                  }
                }}
              >
                <Eye size={16} style={{ marginRight: '6px' }} />
                View Profile
              </button> */}
            </div>

            <div style={contentStyle}>
              {activePage === "login" && <LoginInformation />}
              {activePage === "notifications" && <NotificationSettings />}
              {activePage === "privacy" && <Privacy />}
              {activePage === "groupinvites" && <GroupInvites />}
              {activePage === "exportdata" && <ExportData />}
              {activePage === "deleteaccount" && <DeleteAccount />}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
